import React, { useState } from 'react';

const navigation = {
  platform: [
    { name: 'Visual Editor', href: '/platform/visual-editor' },
    { name: 'Agent', href: '/platform/agent' },
    { name: 'Projects Dashboard', href: '/platform/projects-dashboard' },
    { name: 'Live Previews', href: '/platform/live-previews' },
    { name: 'Team Collaboration', href: '/platform/team-collaboration' },
    { name: 'Export & Share', href: '/platform/export-and-share' },
  ],
  solutions: [
    { name: 'For Engineers', href: '/solutions/for-engineers' },
    { name: 'For Ops & Analysts', href: '/solutions/for-ops-and-analysts' },
    { name: 'For Students', href: '/solutions/for-students' },
    { name: 'For Researchers', href: '/solutions/for-researchers' },
    { name: 'For Internal Tools', href: '/solutions/for-internal-tools' },
    { name: 'For Interactive Reports', href: '/solutions/for-interactive-reports' },
    { name: 'For Exploratory Analysis', href: '/solutions/for-exploratory-analysis' },
    { name: 'For Client-Facing Dashboards', href: '/solutions/for-client-facing-dashboards' },
    { name: 'Enterprises', href: '/solutions/for-enterprises' },
    { name: 'Governments', href: '/solutions/for-governments' },
  ],
  developers: [
    { name: 'Quickstart Guide', href: 'https://docs.preswald.com/quickstart' },
    { name: 'Documentation', href: 'https://docs.preswald.com' },
    { name: 'GitHub', href: 'https://github.com/StructuredLabs/preswald' },
    { name: 'Changelog', href: 'https://github.com/StructuredLabs/preswald/releases' },
    { name: 'Issues', href: 'https://github.com/StructuredLabs/preswald/issues' },
    { name: 'Contributing', href: 'https://github.com/StructuredLabs/preswald/blob/main/CONTRIBUTING.md' },
    { name: 'Community', href:  'https://join.slack.com/t/structuredlabs-users/shared_invite/zt-33zwhyv3l-6Xu4bHL6b6~bI3z9fvlUig' },
  ],
  resources: [
    { name: 'Pricing', href: '/pricing' },
    { name: 'Blog', href: '/blog' },
    { name: 'Careers', href: 'https://www.ycombinator.com/companies/structured-labs/jobs' },
    { name: 'Contact', href: 'mailto:contact@structuredlabs.com' },
    { name: 'Book a Demo', href: 'https://cal.com/amruthagujjar/30min' },
    { name: 'Hackathon', href: '/hackathon', target: '_blank', rel: 'noopener noreferrer' },
    { name: 'Status', href: 'https://preswald.instatus.com/' },
  ],
  social: [
    {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/company/structuredlabs/',
      icon: (props: React.SVGProps<SVGSVGElement>) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      ),
    },
    {
      name: 'X',
      href: 'https://x.com/StructuredLabs',
      icon: (props: React.SVGProps<SVGSVGElement>) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path d="M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75404L10.7663 14.0113L15.5685 21H20.8131L13.6819 10.6218H13.6823ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.096V13.0956Z" />
        </svg>
      ),
    },
    {
      name: 'Slack',
      href: 'https://join.slack.com/t/structuredlabs-users/shared_invite/zt-33zwhyv3l-6Xu4bHL6b6~bI3z9fvlUig',
      icon: (props: React.SVGProps<SVGSVGElement>) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path d="M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zM6.313 15.165a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313zM8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zM8.834 6.313a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312zM18.956 8.834a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zM17.688 8.834a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312zM15.165 18.956a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52zM15.165 17.688a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z"/>
        </svg>
      ),
    },
    {
      name: 'GitHub',
      href: 'https://github.com/StructuredLabs/preswald',
      icon: (props: React.SVGProps<SVGSVGElement>) => (
        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
          <path
            fillRule="evenodd"
            d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },
  ],
}

const INIT = "INIT";
const SUBMITTING = "SUBMITTING";
const ERROR = "ERROR";
const SUCCESS = "SUCCESS";
type FormState = typeof INIT | typeof SUBMITTING | typeof ERROR | typeof SUCCESS;

const formStyles = {
  "id": "clpysj3ir008hl70rn55vz3kp",
  "name": "Default",
  "formStyle": "inline",
  "placeholderText": "Enter your email",
  "formFont": "Inter",
  "formFontColor": "#000000",
  "formFontSizePx": "14",
  "buttonText": "Subscribe",
  "buttonFont": "Inter",
  "buttonFontColor": "#ffffff",
  "buttonColor": "#000000",
  "buttonFontSizePx": 14,
  "successMessage": "Thanks! We'll be in touch!",
  "successFont": "Inter",
  "successFontColor": "#000000",
  "successFontSizePx": 14,
  "userGroup": ""
}

const domain = "app.loops.so"

function isValidEmail(email: string) {
  return /.+@.+/.test(email);
}

export default function LandingFooter() {
  const [email, setEmail] = useState("");
  const [formState, setFormState] = useState<FormState>(INIT);
  const [errorMessage, setErrorMessage] = useState("");

  const resetForm = () => {
    setEmail("");
    setFormState(INIT);
    setErrorMessage("");
  };

  const hasRecentSubmission = () => {
    const time = new Date();
    const timestamp = time.valueOf();
    const previousTimestamp = localStorage.getItem("loops-form-timestamp");

    if (
      previousTimestamp &&
      Number(previousTimestamp) + 60 * 1000 > timestamp
    ) {
      setFormState(ERROR);
      setErrorMessage("Too many signups, please try again in a little while");
      return true;
    }

    localStorage.setItem("loops-form-timestamp", timestamp.toString());
    return false;
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (formState !== INIT) return;
    if (!isValidEmail(email)) {
      setFormState(ERROR);
      setErrorMessage("Please enter a valid email");
      return;
    }
    if (hasRecentSubmission()) return;
    setFormState(SUBMITTING);

    const formBody = `userGroup=${encodeURIComponent(
      formStyles.userGroup
    )}&email=${encodeURIComponent(email)}&mailingLists=`;

    fetch(`https://${domain}/api/newsletter-form/${formStyles.id}`, {
      method: "POST",
      body: formBody,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((res: Response) => {
        const ok = res.ok;
        const dataPromise = res.json();
        return Promise.all([ok, dataPromise, res]);
      })
      .then(([ok, data, res]: [boolean, { message: string }, Response]) => {
        if (ok) {
          resetForm();
          setFormState(SUCCESS);
        } else {
          setFormState(ERROR);
          setErrorMessage(data.message || res.statusText);
          localStorage.setItem("loops-form-timestamp", "");
        }
      })
      .catch((error: Error) => {
        setFormState(ERROR);
        if (error.message === "Failed to fetch") {
          setErrorMessage("Too many signups, please try again in a little while");
        } else if (error.message) {
          setErrorMessage(error.message);
        }
        localStorage.setItem("loops-form-timestamp", "");
      });
  };

  return (
    <footer className="bg-white font-sans border border-[#e0e0e0]">
      <div className="mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-24 lg:px-8 lg:pt-32">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div>
            <img
              alt="Preswald"
              src="/logo.png"
              className="h-8"
            />
            <div className="mt-6 space-y-3 sm:mt-8">
              <a href="https://www.producthunt.com/posts/preswald-2?embed=true&utm_source=badge-top-post-badge&utm_medium=badge&utm_source=badge-preswald&#0045;2" target="_blank" rel="noopener noreferrer" className="block">
                <img src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=960127&theme=light&period=daily&t=1747725997674" alt="Preswald - AI agent for building data apps, dashboards and reports | Product Hunt" className="w-[250px] h-[54px]" width="250" height="54" />
              </a>
              <a href="https://www.producthunt.com/posts/preswald-2?embed=true&utm_source=badge-top-post-topic-badge&utm_medium=badge&utm_source=badge-preswald&#0045;2" target="_blank" rel="noopener noreferrer" className="block">
                <img src="https://api.producthunt.com/widgets/embed-image/v1/top-post-topic-badge.svg?post_id=960127&theme=light&period=weekly&topic_id=267&t=1747725997674" alt="Preswald - AI agent for building data apps, dashboards and reports | Product Hunt" className="w-[250px] h-[54px]" width="250" height="54" />
              </a>
            </div>
          </div>
          <div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm/6 font-semibold tracking-tight text-gray-900">Platform</h3>
                <ul role="list" className="mt-6 space-y-4">
                  {navigation.platform.map((item) => (
                    <li key={item.name}>
                      <a href={item.href} className="text-sm/6 font-medium text-gray-600 hover:text-gray-900" {...(item.href.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-10 md:mt-0">
                <h3 className="text-sm/6 font-semibold tracking-tight text-gray-900">Solutions</h3>
                <ul role="list" className="mt-6 space-y-4">
                  {navigation.solutions.map((item) => (
                    <li key={item.name}>
                      <a href={item.href} className="text-sm/6 font-medium text-gray-600 hover:text-gray-900" {...(item.href.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm/6 font-semibold tracking-tight text-gray-900">Developers</h3>
                <ul role="list" className="mt-6 space-y-4">
                  {navigation.developers.map((item) => (
                    <li key={item.name}>
                      <a href={item.href} className="text-sm/6 font-medium text-gray-600 hover:text-gray-900" target="_blank" rel="noopener noreferrer">
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-10 md:mt-0">
                <h3 className="text-sm/6 font-semibold tracking-tight text-gray-900">Resources</h3>
                <ul role="list" className="mt-6 space-y-4">
                  {navigation.resources.map((item) => (
                    <li key={item.name}>
                      <a href={item.href} className="text-sm/6 font-medium text-gray-600 hover:text-gray-900" {...(item.href.startsWith('http') || item.target ? { target: item.target || '_blank', rel: item.rel || 'noopener noreferrer' } : {})}>
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
                <h3 className="text-sm/6 font-semibold tracking-tight text-gray-900 mt-8">Legal</h3>
                <ul role="list" className="mt-6 space-y-4">
                  <li>
                    <a href="/privacy-policy" className="text-sm/6 font-medium text-gray-600 hover:text-gray-900" target="_blank" rel="noopener noreferrer">
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a href="/terms-and-conditions" className="text-sm/6 font-medium text-gray-600 hover:text-gray-900" target="_blank" rel="noopener noreferrer">
                      Terms and Conditions
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 border-t border-gray-900/10 pt-8 sm:mt-20 lg:mt-24 lg:flex lg:items-center lg:justify-between">
          <div>
            <h3 className="text-sm/6 font-semibold tracking-tight text-gray-900">Subscribe to our newsletter</h3>
            <p className="mt-2 text-sm/6 text-gray-600 font-sans">
              The latest news, articles, and resources, sent to your inbox weekly.
            </p>
          </div>
          {formState === SUCCESS ? (
            <div className="mt-6 sm:flex sm:max-w-md lg:mt-0">
              <p
                style={{
                  fontFamily: `'${formStyles.successFont}', sans-serif`,
                  color: formStyles.successFontColor,
                  fontSize: `${formStyles.successFontSizePx}px`,
                }}
              >
                {formStyles.successMessage}
              </p>
            </div>
          ) : formState === ERROR ? (
            <div className="mt-6 sm:flex sm:max-w-md lg:mt-0">
              <div className="flex flex-col items-center">
                <p className="font-inter text-red-700 text-sm">
                  {errorMessage || "Oops! Something went wrong, please try again"}
                </p>
                <button
                  className="text-gray-500 text-sm mt-2 bg-transparent border-none cursor-pointer hover:underline"
                  onClick={resetForm}
                >
                  &larr; Back
                </button>
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="mt-6 sm:flex sm:max-w-md lg:mt-0">
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email-address"
                type="email"
                required
                placeholder={formStyles.placeholderText}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                className="w-full min-w-0 rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:w-56 sm:text-sm/6"
              />
              <div className="mt-4 sm:ml-4 sm:mt-0 sm:shrink-0">
                <button
                  type="submit"
                  disabled={formState === SUBMITTING}
                  className="flex w-full items-center justify-center rounded-md bg-slate-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-slate-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50"
                >
                  {formState === SUBMITTING ? "Please wait..." : formStyles.buttonText}
                </button>
              </div>
            </form>
          )}
        </div>
        <div className="mt-8 border-t border-gray-900/10 pt-8 md:flex md:items-center md:justify-between">
          <div className="flex gap-x-6 md:order-2">
            {navigation.social.map((item) => (
              <a key={item.name} href={item.href} className="text-gray-600 hover:text-gray-800" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">{item.name}</span>
                <item.icon aria-hidden="true" className="size-6" />
              </a>
            ))}
          </div>
          <p className="mt-8 text-sm/6 text-gray-600 md:order-1 md:mt-0">
            &copy; 2025 Structured Labs, Inc. All rights reserved.
          </p>
        </div>
        <div className="mt-8">
          <iframe 
            src="https://preswald.instatus.com/embed-status/3c2c6101/light-sm" 
            width="230" 
            height="61" 
            frameBorder="0" 
            scrolling="no" 
            style={{ border: 'none' }}
            title="System Status"
          />
        </div>
      </div>
    </footer>
  )
}
